import '@operato/font'

import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

import { PageView } from '@operato/shell'

@customElement('font-list-page')
export class FontListPage extends PageView {
  static styles = [
    css`
      :host {
        display: flex;
      }

      font-selector {
        flex: 1;
      }
    `
  ]

  get context() {
    return {
      title: 'font list'
    }
  }

  render() {
    return html` <font-selector .creatable=${true}></font-selector> `
  }
}
